import React from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { activities } from '../data/mock';

const ActivitiesPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-6xl mx-auto px-4">
          {/* Hero */}
          <div className="text-center mb-16">
            <h1 className="heading-1 mb-4">11 Learning Modules</h1>
            <p className="body-large max-w-2xl mx-auto">
              Master every aspect of English communication through our comprehensive, 
              AI-powered learning modules designed for real-world success.
            </p>
          </div>

          {/* Activities Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {activities.map((activity) => {
              const IconComponent = LucideIcons[activity.icon] || LucideIcons.Circle;
              
              return (
                <Link
                  key={activity.id}
                  to={`/activities/${activity.id}`}
                  className="activity-card group"
                  style={{ '--card-accent-color': activity.color }}
                >
                  <div 
                    className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4"
                    style={{ backgroundColor: `${activity.color}15` }}
                  >
                    <IconComponent 
                      className="w-7 h-7" 
                      style={{ color: activity.color }}
                    />
                  </div>

                  <h3 className="font-semibold text-xl text-[#1a1a2e] mb-2 group-hover:text-[#3459a4] transition-colors">
                    {activity.name}
                  </h3>
                  <p className="text-[#83928c] mb-4">
                    {activity.description}
                  </p>

                  <div className="flex flex-wrap gap-2 mb-4">
                    {activity.skills.map((skill) => (
                      <span 
                        key={skill}
                        className="text-xs px-3 py-1 rounded-full bg-black/5 text-[#83928c]"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>

                  <div className="mt-auto">
                    <span className="text-sm text-[#3459a4] font-medium group-hover:underline">
                      Learn more →
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>

          {/* CTA */}
          <div className="text-center mt-16">
            <p className="text-[#83928c] mb-4">
              Ready to master all 11 modules and get certified?
            </p>
            <a href="https://app.tenses.ai" className="btn-primary">
              Get started
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ActivitiesPage;
